export default function PlaneIcon({ className }: { className?: string }) {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        id="Vector"
        d="M18.2057 25.9244C18.0352 26.3937 17.7062 26.6672 17.219 26.7449C16.7317 26.8227 16.2974 26.6709 15.9162 26.2897L11.6526 22.0261C11.4026 21.7761 11.2524 21.4909 11.2019 21.1703C11.1514 20.8498 11.1904 20.5585 11.3188 20.2964L16.1626 11.189L7.00096 15.9785C6.73887 16.107 6.44756 16.1459 6.12703 16.0955C5.80648 16.045 5.52122 15.8948 5.27125 15.6448L1.0619 11.4354C0.680656 11.0542 0.528914 10.6199 0.606673 10.1326C0.684416 9.64535 0.95281 9.31133 1.41185 9.13056L24.2794 1.06297C24.8506 0.862787 25.3783 1.00481 25.8626 1.48903C26.3468 1.97325 26.4888 2.50097 26.2886 3.07218L18.2057 25.9244Z"
        fill="currentColor"
      />
    </svg>
  )
}
